/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientRefResponse } from './';
import {
    ClientRefResponseFromJSON,
    ClientRefResponseFromJSONTyped,
    ClientRefResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentifiedCompanyResponse
 */
export interface IdentifiedCompanyResponse {
    /**
     * 
     * @type {string}
     * @memberof IdentifiedCompanyResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IdentifiedCompanyResponse
     */
    companyId: string;
    /**
     * 
     * @type {ClientRefResponse}
     * @memberof IdentifiedCompanyResponse
     */
    client?: ClientRefResponse;
}

/**
 * Check if a given object implements the IdentifiedCompanyResponse interface.
 */
export function instanceOfIdentifiedCompanyResponse(value: object): value is IdentifiedCompanyResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function IdentifiedCompanyResponseFromJSON(json: any): IdentifiedCompanyResponse {
    return IdentifiedCompanyResponseFromJSONTyped(json, false);
}

export function IdentifiedCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentifiedCompanyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'companyId': json['companyId'],
        'client': json['client'] == null ? undefined : ClientRefResponseFromJSON(json['client']),
    };
}

export function IdentifiedCompanyResponseToJSON(value?: IdentifiedCompanyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'companyId': value['companyId'],
        'client': ClientRefResponseToJSON(value['client']),
    };
}

